import PropTypes from 'prop-types';
import React from 'react';
import { openModal } from 'modal-core-components';
import CCModalContainer from './CCModalContainer';

const openCCModal = (onSend, clientId) => {
  openModal(closeModal => (
    <CCModalContainer onClose={closeModal} onSend={onSend} clientId={clientId} />
  ));
};

openCCModal.propTypes = {
  onSend: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
};

export default openCCModal;
